import { useSelector } from "react-redux";
import React, { ReactNode, useCallback } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, MenuBarEliminateRecursion } from "@maysoft/common-component-react";

import Helpers from "commons/helpers";
import Screens from "constants/screens";
import Strings from "constants/strings";
import Constants from "constants/index";

import { RootState } from "store";
import { ITitleRoute } from "commons/interfaces";
import { useMapScreenName } from "routes/mapScreenName";


type variantButton = "text" | "contained" | "outlined" | "gradient";
type colorButton = "white" | "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark" | "default";
interface IProps {
    title?: string;
    route?: ITitleRoute[];
    children: ReactNode;
    listActions?: {
        title?: ReactNode;
        color?: colorButton;
        variant?: variantButton;
        onPress?: (data: any) => void;
    }[];
};

const SettingLayout: React.FC<IProps> = (props: IProps) => {

    const navigate = useNavigate();
    const location = useLocation();
    const dataMapScreenName = useMapScreenName();

    const w767 = useMediaQuery("(max-width: 767px)");

    const { menuDetails, listPathName, } = useSelector((state: RootState) => state.titleRoute);

    const onMenuNavigate = useCallback((pathName: string) => {
        navigate(pathName);
    }, [navigate]);

    const onChangeDisplayLanguage = useCallback((value: string) => {
        Strings.setLanguage(value);
        Helpers.setItemInLocalStorage(Constants.StorageKeys.LANGUAGE, value);

        __EventEmitter.emit(Constants.EventName.LANGUAGE_CHANGE);
    }, []);

    return (
        <Grid container spacing={3} alignItems={"stretch"}>
            <Grid item xs={12} md={4} lg={3}>
                <Card sx={{
                    mt: w767 ? "16px" : "64px",
                    height: `calc(100% - ${w767 ? "16px" : "64px"})`
                }}>
                    <MenuBarEliminateRecursion
                        openMenu
                        modeSelected={w767}
                        hiddenSwitchLanguage
                        dataMenu={[...menuDetails || []]}
                        dataMapScreenName={dataMapScreenName}

                        lengthGeneParent={10}
                        borderRadius={"0.75rem"}
                        pathNameDefault={Screens.HOME}
                        pathNameCurrent={location?.pathname}
                        listPathName={[...listPathName || []]}

                        onNavigate={onMenuNavigate}
                        onChangeLanguage={onChangeDisplayLanguage}

                        color={{
                            background: "#fff",
                            text: "#000",
                            hoverText: "#000",
                            activeText: "#fff",
                            hoverMenu: "#cdcdcd",
                            activeMenu: "#191919",
                            activeSubMenu: "#191919",
                        }}
                    />
                </Card>
            </Grid>
            <Grid item xs={12} md={8} lg={9}>
                {[...props.listActions || []].length > 0 &&
                    <Box sx={{
                        mb: 3,
                        gap: 1,
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        justifyContent: "end",
                    }}>
                        {[...props.listActions || []].map((item, index) => (
                            <Button
                                key={index}
                                color={item.color}
                                onClick={item.onPress}
                                variant={item.variant}
                            >
                                {item.title}
                            </Button>
                        ))}
                    </Box>
                }
                {props.children}
            </Grid>
        </Grid>
    );
};

export default SettingLayout;
